import JxFormFieldsBase from '../../JxControls/JxForms/JxFormFieldsBase';
import { createLayout } from './TestDlgSchema';

/**
 * TestDlgBody — form fields for TestDlg.
 * Extends JxFormFieldsBase for shared FieldRow/Section rendering.
 * System fields are commented out — uncomment + add copyable when needed.
 * FieldRow picks up label, control, readonly and layout from createLayout() via spread.
 * Consecutive top-label fields are wrapped in a flex row automatically.
 */
export default class TestDlgBody extends JxFormFieldsBase {
    layout = createLayout();

    constructor(props) {
        super(props);
        this.name = 'TestDlgBody';
    }

    render() {
        const { Section, FieldRow } = this;
        const { layout } = this;

        return (
            <>
                {/* system fields */}
                {/* <FieldRow field="rk" {...layout.rk} copyable /> */}
                {/* <FieldRow field="ems" {...layout.ems} copyable /> */}

                <FieldRow field="uid" {...layout.uid} />
                <FieldRow field="tabId" {...layout.tabId} />
                <FieldRow field="component" {...layout.component} />
                <div style={{ display: 'flex', gap: 8 }}>
                    <FieldRow field="posX" {...layout.posX} />
                    <FieldRow field="posY" {...layout.posY} />
                    <FieldRow field="height" {...layout.height} />
                    <FieldRow field="width" {...layout.width} />
                </div>
            </>
        );
    }
}
